import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";
import {errorBase} from "../../../config";
export const StyledFormFieldError= styled(Typography)(({theme}) => ({
    color: errorBase,
    fontWeight: '400',
    fontSize: '0.75rem',
    lineHeight: 1.66,
}));